import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useUser } from 'components/providers/UserProvider'
import { editUserAttribute } from 'lib/api'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

interface NotificationCenterProps {
  showRelistingsBanner?: boolean
  showConflictsBanner?: boolean
  numberOfConflicts?: number
  displayTaxationMessage: boolean
  setDisplayTaxationMessage: React.Dispatch<React.SetStateAction<boolean>>
}

export const NotificationCenter = ({
  showRelistingsBanner,
  showConflictsBanner,
  numberOfConflicts,
  displayTaxationMessage,
}: NotificationCenterProps): JSX.Element => {
  const { t } = useTranslation()
  const { user, setUser } = useUser()
  const history = useHistory()

  const updateUserSettings = async () => {
    const notifications = user.enabledNotifications
    const response = await editUserAttribute(
      {
        ...notifications,
        displayTaxationMessageInDashboard: false,
      },
      'enabledNotifications'
    )
    setUser({ ...user, ...response })

    history.push('/taxation')
  }

  return (
    <>
      <Accordion className="dashboard-notification-center">
        <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel-header">
          <div className="d-flex flex-row align-items-center">
            <i className="fa-light fa-bell"></i>
            <h4 className="m-0">{t('dashboard.notificationCenter')}</h4>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="d-flex flex-column w-100">
            {showRelistingsBanner && (
              <div className="notification-center-content">
                <Typography variant="body1" component="span">
                  <span>{t('ptInventory.relisting.dashboardBanner')}</span>
                  <span
                    className="span-as-link ms-2"
                    data-testid="relisting-page"
                    onClick={() => history.push('/relisting')}
                  >
                    {t('ptInventory.linkText')}
                  </span>
                </Typography>
              </div>
            )}

            {showConflictsBanner && (
              <div className="notification-center-content">
                <Typography variant="body1" component="span">
                  {t('ptInventory.tooManyConflicts', { numConflicts: numberOfConflicts })}{' '}
                  <a href="/inventory">{t('ptInventory.linkText')}</a>
                </Typography>
              </div>
            )}

            {displayTaxationMessage && (
              <div className="notification-center-content">
                <Typography variant="body1" component="span">
                  We've released a new feature that tracks the tax status of product sales and
                  purchases. Check it out
                  <a onClick={() => updateUserSettings()}> here</a>
                </Typography>
              </div>
            )}
          </div>
        </AccordionDetails>
      </Accordion>
    </>
  )
}
